export const environment = {
    apiUrl: 'https://test-api.zignflix.com/admin-api/',
    zignFlixApiUrl: 'https://test-api.zignflix.com/api/',
    zignFlixUrl: 'https://test-studio.zignflix.com/'
};
